import { getAuthAxiosBackend } from "@/helpers/axios"

class IssuersResidentialCardsServices {
    get(id) {
        return getAuthAxiosBackend().get('IssuersResidentialCards/getIssuersResidentialCard/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('IssuersResidentialCards/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('IssuersResidentialCards/addIssuersResidentialCard', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('IssuersResidentialCards/updateIssuersResidentialCard/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('IssuersResidentialCards/restoreIssuersResidentialCard/' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('IssuersResidentialCards/softDeleteIssuersResidentialCard/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('IssuersResidentialCards/deleteIssuersResidentialCard/' + id.toString())
    }
}

export default new IssuersResidentialCardsServices()
